import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11.8432 15.8176L11.3579 22.5184C12.0522 22.5184 12.3528 22.2256 12.7134 21.874L15.9683 18.82L22.7126 23.6692C23.9496 24.346 24.821 23.9896 25.1547 22.552L29.5817 2.18568L29.5829 2.18448C29.9753 0.389285 28.9217 -0.312712 27.7165 0.127686L1.69481 9.90884C-0.081118 10.5856 -0.0542285 11.5576 1.39292 11.998L8.04563 14.0296L23.4986 4.53646C24.2258 4.06367 24.887 4.32526 24.3431 4.79806L11.8432 15.8176Z",
            fill: "white"
        })
    }));
};
export default Icon;
